export default "__VITE_ASSET__a2d18218__"